module.exports = __webpack_public_path__ + "static/media/david_profile_pic_square_800.fe24bcd1.jpg";